import {
  ADD_CATALOG_APP,
  RESET_ADD_CUSTOM_APP_ERROR,
  CLEAR_ADD_CUSTOM_TEMPLATE_FILE_ERROR,
  GET_CUSTOM_APP_ID,
} from '../../actions/index'
const initialState = {
  addCustomTemplateFile: {
    isUploading: false,
    errors: null,
    errorMessage: '',
  },
  createGenApp: {
    appContainerId: '',
    error: '',
    fetchingGenAppId: false,
  },
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case `${ADD_CATALOG_APP}_SUCCESS`: {
      return {
        ...state,
        addCustomTemplateFile: {
          isUploading: false,
          error: null,
          errorMessage: '',
        },
      }
    }
    case `${ADD_CATALOG_APP}_REJECTED`: {
      const { message } = action.payload.response.data

      const errMsgs =
        message.includes(': [') && message.includes(']')
          ? [
              message.split(': [')[0].trim(),
              ...message
                .slice(message.indexOf('[') + 1, message.lastIndexOf(']'))
                .split(',')
                .map(m => m.trim()),
            ]
          : [message.trim()]

      return {
        ...state,
        addCustomTemplateFile: {
          isUploading: false,
          errors: errMsgs,
          errorMessage: action.errorMessage,
        },
      }
    }
    case `${ADD_CATALOG_APP}_PENDING`: {
      return {
        ...state,
        addCustomTemplateFile: {
          isUploading: true,
          error: null,
          errorMessage: '',
        },
      }
    }
    case `${CLEAR_ADD_CUSTOM_TEMPLATE_FILE_ERROR}`: {
      return {
        addCustomTemplateFile: { errors: null, errorMessage: '' },
      }
    }

    /* Getting application ID */

    case `${GET_CUSTOM_APP_ID}_PENDING`:
      return {
        ...state,
        createGenApp: {
          appContainerId: '',
          fetchingGenAppId: true,
        },
      }
    case `${GET_CUSTOM_APP_ID}_FULFILLED`:
      return {
        ...state,
        createGenApp: {
          appContainerId: action.payload.data.appContainerId,
          fetchingGenAppId: false,
        },
      }
    case `${GET_CUSTOM_APP_ID}_REJECTED`:
      return {
        ...state,
        createGenApp: {
          appContainerId: '',
          error: action.payload.response.data.message,
          fetchingGenAppId: false,
        },
      }
    case `${RESET_ADD_CUSTOM_APP_ERROR}`: {
      return {
        createGenApp: {
          error: null,
          fetchingGenAppId: false,
          appContainerId: '',
        },
      }
    }

    default:
      return { ...state }
  }
}
